module.exports = __webpack_public_path__ + "media/images/medidas-af2c6d53e9699929badbf6a5b6fe76a7.png";